import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  //Filter value initial state
  filterValues: {
    brachArrayWithCode: [],
    branchCode: "",
    branch: [],
    branchValue: null,
    paymentTypeWithDesArray: [],
    paymentTypeArray: [],
    paymentType: "",
    paymentCode: "",
    voucherDate: null,
    fundTransferModeArray: [],
    fundTransferMode: "",
    paymentBankArray: [],
    paymentBankOrCash: "",
    paymentBankCode: "",
    paymentBankBranchKey: "",
  },
  initialLoad: {
    emiStartDate: "",
    emiAmt: "",
    customerName: "",
    bankName: "",
    bankBranchName: "",
    accountType: "",
    ifsc: "",
    bankAccNum: "",
  },
  //Detail screen initial state
  gridValues: {
    rows: [],
    applicationNumberArray: [],
    GLValAndDesArray: [],
    allBranchGlAccounts: [],
    GLAccountArray: [],
    favourName: [],
  },
  HideComponents: {
    showGridComponent: false,
    //Glaccount enable in grid only after selecting the application number in the grid
    glDisplay: true,
    applicationNumberDisplay: true,
  },

  modalValue: {
    customerName: "",
    bankName: "",
    bankBranchName: "",
    ifsc: "",
    bankAccNum: "",
    accountType: "",
    emiStartDate: "",
    emiAmt: "",
  },
  //Error Handling Initial States
  filterValueTouched: {
    branchTouch: false,
    paymentTypeTouch: false,
    voucherDateTouch: false,
    fundTransferModeIsTouched: false,
    paymentBankOrCashIsTouched: false,
  },
  filterValueIsValid: {
    branchIsValid: false,
    paymentTypeIsValid: false,
    voucherDateIsValid: false,
    fundTransferModeIsValid: false,
    paymentBankOrCashIsValid: false,
  },
  //Validation
  validation: {
    Gldes: [],
    errorApplicationNumber: [],
  },
  //BackEnd API's
  API: {
    paymentType: [
      { type: "NEFT", description: "NEFT001" },
      { type: "UPI", description: "UPI002" },
    ],
    paymentArray: [],
  },
};
const FilePaymentReducer = createSlice({
  name: "file",
  initialState: initialState,
  reducers: {
    //Methods for updating Filter Values
    updateBrachArrayWithCode(state, action) {
      state.filterValues.brachArrayWithCode = action.payload;
    },
    updateBranchCode(state, action) {
      state.filterValues.branchCode = action.payload;
    },
    updateBranchArray(state, action) {
      state.filterValues.branch = action.payload;
    },
    updateBranchValue(state, action) {
      state.filterValues.branchValue = action.payload;
      state.filterValueIsValid.branchIsValid =
        action.payload !== "" && action.payload !== null;
    },
    updatePaymentTypeArray(state, action) {
      state.filterValues.paymentTypeArray = action.payload;
    },
    updatePaymentType(state, action) {
      state.filterValues.paymentType = action.payload;
      state.filterValueIsValid.paymentTypeIsValid =
        action.payload !== "" && action.payload !== null;
    },
    updateFundTransferModeArray(state, action) {
      state.filterValues.fundTransferModeArray = action.payload;
    },
    updateFundTransferMode(state, action) {
      state.filterValues.fundTransferMode = action.payload;
      state.filterValueIsValid.fundTransferModeIsValid =
        action.payload !== "" && action.payload !== null;
    },
    updatePaymentCode(state, action) {
      state.filterValues.paymentCode = action.payload;
    },
    updateVoucherDate(state, action) {
      state.filterValues.voucherDate = action.payload;
      state.filterValueIsValid.voucherDateIsValid =
        action.payload !== "" &&
        action.payload !== null &&
        new Date(action.payload).toDateString() !== "Invalid Date" &&
        new Date(action.payload).toLocaleDateString().slice(-4) >= "1970" &&
        new Date(action.payload).toLocaleDateString().slice(-4) <= "2055";
    },
    updatePaymentBankArray(state, action) {
      state.filterValues.paymentBankArray = action.payload;
    },
    updatePaymentBankValue(state, action) {
      state.filterValues.paymentBankOrCash = action.payload;
      state.filterValueIsValid.paymentBankOrCashIsValid =
        action.payload !== "" && action.payload !== null;
    },
    updatepaymentBankCode(state, action) {
      state.filterValues.paymentBankCode = action.payload;
    },
    updatepaymentBankBranchKey(state, action) {
      state.filterValues.paymentBankBranchKey = action.payload;
    },
    //Hide or Show components methods
    updateShowGridCompponent(state, action) {
      state.HideComponents.showGridComponent = action.payload;
    },
    updateGlDisplay(state, action) {
      state.HideComponents.glDisplay = action.payload;
    },
    updateApplicationDisplay(state, action) {
      state.HideComponents.applicationNumberDisplay = action.payload;
    },

    //Detail screen update methods
    addRows(state, action) {
      state.gridValues.rows = [...state.gridValues.rows, action.payload];
    },
    updateRows(state, action) {
      state.gridValues.rows = action.payload;
    },

    //gridValues
    updateApplicationArray(state, action) {
      state.gridValues.applicationNumberArray = action.payload;
    },
    updateAllBranchGlAccounts(state, action) {
      state.gridValues.allBranchGlAccounts = action.payload;
    },
    updateGLValAndDesArray(state, action) {
      state.gridValues.GLValAndDesArray = action.payload;
    },
    updateGLAccountArray(state, action) {
      state.gridValues.GLAccountArray = action.payload;
    },
    updateFavourName(state, action) {
      state.gridValues.favourName = action.payload;
    },
    //Reducers for updating modal value
    updateModalValue(state, action) {
      state.modalValue.customerName = action.payload.customerName;
      state.modalValue.bankName = action.payload.bankName;
      state.modalValue.bankBranchName = action.payload.bankBranchName;
      state.modalValue.ifsc = action.payload.ifsc;
      state.modalValue.bankAccNum = action.payload.bankAccNum;
      state.modalValue.accountType = action.payload.accountType;
      state.modalValue.emiStartDate = action.payload.emiStartDate;
      state.modalValue.emiAmt = action.payload.emiAmt;
    },
    //Error Handling Reducers
    updateBranchIsTouched(state, action) {
      state.filterValueTouched.branchTouch = action.payload;
    },
    updatePaymentTypeIsTouched(state, action) {
      state.filterValueTouched.paymentTypeTouch = action.payload;
    },
    updateVoucherDateIsTouched(state, action) {
      state.filterValueTouched.voucherDateTouch = action.payload;
    },
    updateFundTransferModeIsTouched(state, action) {
      state.filterValueTouched.fundTransferModeIsTouched = action.payload;
    },
    updatePaymentBankOrCashIsTouched(state, action) {
      state.filterValueTouched.paymentBankOrCashIsTouched = action.payload;
    },
    //Validation Reducers
    updateValidationGlDes(state, action) {
      state.validation.Gldes = action.payload;
    },
    updateErrorApplicationDetails(state, action) {
      state.validation.errorApplicationNumber = action.payload;
    },
    //Dummy Fields
    updateBankDetails(state, action) {
      state.initialLoad.customerName = action.payload.accHoldrName;
      state.initialLoad.bankName = action.payload.bankName;
      state.initialLoad.bankBranchName = action.payload.bankBranchName;
      state.initialLoad.accountType = action.payload.bankAccountType;
      state.initialLoad.ifsc = action.payload.ifscCode;
      state.initialLoad.bankAccNum = action.payload.bankAccountNum;
    },
    updateEmiStatus(state, action) {
      state.initialLoad.emiStartDate = action.payload.emiStartDate
        ? action.payload.emiStartDate
        : null;
      state.initialLoad.emiAmt = action.payload.emiAmt
        ? action.payload.emiAmt
        : "";
    },

    //API
    updatePaymentTypeWithDesArray(state, action) {
      state.filterValues.paymentTypeWithDesArray = action.payload;
    },
    branchChangeResetHandler(state, action) {
      state.filterValues.paymentType = "";
      state.filterValueIsValid.paymentTypeIsValid = false;
      state.filterValues.voucherDate = null;
      state.filterValueIsValid.voucherDateIsValid = false;
      state.filterValues.paymentCode = "";
      state.filterValues.fundTransferMode = "";
      state.filterValues.paymentBankOrCash = "";
      state.filterValues.paymentBankCode = "";
      state.filterValues.paymentBankBranchKey = "";
      state.filterValueIsValid.paymentBankOrCashIsValid = false;
      state.HideComponents.showGridComponent = false;
      state.filterValueIsValid.fundTransferModeIsValid = false;
      state.filterValues.fundTransferMode = "";
      state.gridValues.applicationNumberArray = [];
    },
    paymentTypeResetHandler(state, action) {
      state.filterValueTouched.fundTransferModeIsTouched = false;
      state.filterValueIsValid.fundTransferModeIsValid = false;
      state.filterValues.fundTransferMode = "";
      state.gridValues.applicationNumberArray = [];
    },
    //Reset Value
    resetHandler(state, action) {
      state.filterValues.branchValue = "";
      state.filterValueTouched.branchTouch = false;
      state.filterValueIsValid.branchIsValid = false;

      state.filterValues.applicationNumberArray = [];
      state.filterValues.applicationNumberValue = "";

      state.filterValues.paymentTypeArray = [];
      state.filterValues.paymentType = "";
      state.filterValueIsValid.paymentTypeIsValid = false;
      state.filterValueTouched.paymentTypeTouch = false;

      state.filterValues.voucherDate = null;
      state.filterValueIsValid.voucherDateIsValid = false;
      state.filterValueTouched.voucherDateTouch = false;

      state.filterValues.paymentCode = "";
      state.filterValues.fundTransferMode = "";

      state.filterValues.paymentBankOrCash = "";
      state.filterValues.paymentBankCode = "";
      state.filterValues.paymentBankBranchKey = "";
      state.filterValueTouched.paymentBankOrCashIsTouched = false;
      state.filterValueIsValid.paymentBankOrCashIsValid = false;

      state.gridValues.rows = [];
      state.HideComponents.showGridComponent = false;

      state.filterValueTouched.fundTransferModeIsTouched = false;
      state.filterValueIsValid.fundTransferModeIsValid = false;
      state.filterValues.fundTransferMode = "";
    },
  },
});
export const FilePaymentReducerAction = FilePaymentReducer.actions;
export default FilePaymentReducer.reducer;
